import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilter = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.24977 13.2625C5.96227 13.2625 5.72165 13.1656 5.5279 12.9719C5.33415 12.7781 5.23727 12.5375 5.23727 12.25V7.84375L0.812273 2.18125C0.574773 1.88125 0.540398 1.5625 0.709148 1.225C0.877898 0.8875 1.14977 0.71875 1.52477 0.71875H12.4748C12.8498 0.71875 13.1216 0.8875 13.2904 1.225C13.4591 1.5625 13.4248 1.88125 13.1873 2.18125L8.78102 7.84375V12.3438C8.78102 12.6062 8.6904 12.825 8.50915 13C8.3279 13.175 8.10602 13.2625 7.84352 13.2625H6.24977ZM6.99977 7.675L11.2935 2.21875H2.70602L6.99977 7.675Z",
		fill: "#3C59F6"
	})
});
export default SvgFilter;
